import React, { memo } from 'react'


function Checkbox({ selectHandler, item }) {

    return (
        <input 
            type="checkbox" 
            style={{
                height: 20,
                width: 20,
                marginLeft: 20,
            }}
            checked={item.selected??false}
            onChange={(e)=>{
                selectHandler(item, e.target.checked)
            }}/>
    )
}

export default memo(Checkbox);